import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Divider,
  Icon,
  Spinner,
  Alert,
  AlertIcon,
  VStack,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaBus } from "react-icons/fa";
import Pay_Fee from "./Admin_Modal_Pay_Fee";
import { useParams } from "react-router-dom";
import { BASE_URL } from "../../../Globalapi/Globalapi";

const Student_Profile_Individual = ({ studentId }) => {
  // Colors for light and dark modes
  const [busData, setBusData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { user_id } = useParams();
  const cardBg = useColorModeValue("white", "gray.800");
  const headerBg = useColorModeValue("teal.100", "teal.900");
  const textColor = useColorModeValue("gray.700", "gray.300");
  const iconColor = useColorModeValue("teal.500", "teal.300");
  const dividerColor = useColorModeValue("gray.200", "gray.600");
  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  useEffect(() => {
    const fetchedStudentId = studentId || sessionStorage.getItem("student_id");
    const schoolId = sessionStorage.getItem("school_id");

    const fetchBusData = async () => {
      setLoading(true);
      setError(null);

      try {
        const response = await fetch(
          `${BASE_URL}/student/bus/bus_details.php`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              student_id: fetchedStudentId,
              school_id: schoolId,
            }),
          }
        );
        console.log("details", response);

        if (!response.ok) {
          throw new Error(`Failed to fetch: ${response.status}`);
        }

        const data = await response.json();

        if (data.success) {
          setBusData(data.data);
          console.log("bus data", busData);
        } else {
          setBusData(null); // No bus data available
        }
      } catch (error) {
        console.error("Error fetching bus data:", error);
        setError("Failed to fetch bus details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchBusData();
  }, [studentId]);

  if (loading) {
    return (
      <Flex justify="center" align="center" height="100vh">
        <Spinner size="xl" color="teal.500" />
      </Flex>
    );
  }

  // if (error) {
  //   return (
  //     <Alert status="error">
  //       <AlertIcon />
  //       {error}
  //     </Alert>
  //   );
  // }
  if (!busData) {
    return (
      <Flex justify="center" align="center" >
        <Text fontSize="sm" color={textColor}>
          No bus details available.
        </Text>
      </Flex>
    );
  }
  console.log("userid", user_id);

  return (
    <Box
      width="420px"
      borderWidth="1px"
      borderRadius="lg"
      boxShadow="xl"
      overflow="hidden"
      bg={cardBg}
      fontFamily="Arial, sans-serif"
    >
      {/* Header */}
      <Flex
        borderBottomWidth="1px"
        borderColor={dividerColor}
        bg={headerBg}
        justify="center"
        py="3"
      >
        <Text
          fontSize="md"
          fontWeight="bold"
          color={iconColor}
          textTransform="uppercase"
        >
          Transportation
        </Text>
      </Flex>

      {/* Content */}
      <VStack align="stretch" spacing="5" p="6">
        {/* Route Section */}
        <Flex align="center">
          <Box fontSize="2xl" mr="4" color={iconColor}>
            <Icon as={FaBus} />
          </Box>
          <Box>
            <Text fontSize="xs" color={textColor} textTransform="uppercase">
              Route
            </Text>
            <Text fontSize="sm" fontWeight="bold" color={textColor}>
              {busData.start_place || "N/A"} to {busData.end_place || "N/A"}
            </Text>
          </Box>
        </Flex>

        <Divider borderColor={dividerColor} />

        {/* Info Rows */}
        <Flex justify="space-between">
          <Box>
            <Text fontSize="xs" color={textColor} textTransform="uppercase">
              Pickup Point
            </Text>
            <Text fontSize="sm" fontWeight="bold" color={textColor}>
              {busData.pickup_location_name || "N/A"}
            </Text>
          </Box>
          <Box>
            <Text fontSize="xs" color={textColor} textTransform="uppercase">
              Drop Point
            </Text>
            <Text fontSize="sm" fontWeight="bold" color={textColor}>
              {busData.drop_location_name || "N/A"}
            </Text>
          </Box>
        </Flex>

        <Divider borderColor={dividerColor} />

        {/* Pay Button */}
        <Button
          colorScheme="teal"
          variant="solid"
          width="full"
          size="lg"
          fontWeight="bold"
          onClick={() => handleOpenModal()}
        >
          Pay Bus Fee
        </Button>
      </VStack>
      {isModalOpen && (
        <Pay_Fee
          isOpen={isModalOpen}
          onClose={handleCloseModal}
          // amount={transportInfo.transportFee}
          // last={transportInfo.paymentDueDate}
          // start={transportInfo.startDate}
          // feeId={transportInfo.recordId}
          studentId={studentId}
          userId={user_id}
        />
      )}
    </Box>
  );
};

export default Student_Profile_Individual;
